import React, { FunctionComponent, useLayoutEffect, useMemo, useRef } from 'react';

import { getRootClassName, ScopedTheme, useTheme } from '@yandex-360/orb-components/dist/components/Theme';
import { addClassName } from '@yandex-360/orb-components/dist/helpers/addClassName';
import { removeClassName } from '@yandex-360/orb-components/dist/helpers/removeClassName';

import { useDocumentPictureInPictureContext } from '../../../../../../shared/components/document-pip';
import { getThemeClassName } from '../../../../../../shared/helpers/theme';
import { PiPCallLayout } from '../pip-call-layout';

export const PiPCall: FunctionComponent = () => {
    const { pipDocument } = useDocumentPictureInPictureContext();

    const theme = useTheme()!;

    const pipBodyClassName = useMemo(() => getRootClassName(theme, getThemeClassName(theme), 'telemost'), [theme]);

    const appliedPipBodyClassName = useRef('');
    useLayoutEffect(() => {
        const body = pipDocument.body;
        removeClassName(body.classList, appliedPipBodyClassName.current);
        addClassName(body.classList, pipBodyClassName);
        appliedPipBodyClassName.current = pipBodyClassName;
        return () => {
            removeClassName(body.classList, appliedPipBodyClassName.current);
            appliedPipBodyClassName.current = '';
        };
    }, [pipDocument, pipBodyClassName]);

    return (
        <ScopedTheme theme={theme}>
            <PiPCallLayout />
        </ScopedTheme>
    );
};
